import { ViewType } from '../../types/dashboard';
import {
	PENDING_PERSONAL_OPTION_KEY,
	RESUMEN_OPTION_KEY,
	viewTypeOfPlan
} from '../../utils/viewOptions';
import { SelectablePlan } from './planSelectorItems';

interface PlanNavigationEffects {
	setViewType: (type: string) => void;
	navigateToDefaultTab: (type: string) => void;
	onSelectPersonalPlan?: (planId: string) => void;
	/** Se abre ESTE plan: el Resumen deja de enseñar su traspaso completado (`planVisto`). */
	onOpenPlan?: (planId: string) => void;
}

/**
 * Qué pasa al elegir un plan del selector.
 *
 * Vive aquí y no en cada barra porque escritorio y móvil ofrecen la misma
 * lista: si cada uno resolviera el destino por su cuenta, un día llevarían a
 * sitios distintos. La clasificación es la misma que usa el selector de vistas
 * (`viewTypeOfPlan`), así que una fila sin `type` se decide igual en todo el
 * front.
 */
export const navigateToPlan = (
	plans: SelectablePlan[],
	planId: string,
	{ setViewType, navigateToDefaultTab, onSelectPersonalPlan, onOpenPlan }: PlanNavigationEffects
): void => {
	// El Resumen no es un plan: es la vista de todos (chirigota#585).
	if (planId === RESUMEN_OPTION_KEY) {
		setViewType(ViewType.RESUMEN);
		navigateToDefaultTab(ViewType.RESUMEN);
		return;
	}

	// El plan individual en proceso no es una fila: lleva a la vista personal sin
	// fijar ningún plan, porque todavía no hay ninguno que fijar.
	if (planId === PENDING_PERSONAL_OPTION_KEY) {
		setViewType(ViewType.INDIVIDUAL);
		navigateToDefaultTab(ViewType.INDIVIDUAL);
		return;
	}

	const plan = plans.find((candidate) => candidate.id === planId);
	// Un id que ya no está en la lista no mueve a nadie de sitio.
	if (!plan) return;

	const target = viewTypeOfPlan(plan);
	// 🔴 El plan de EMPLEO no pasa por `onSelectPersonalPlan`: ese handle lo
	// consume la vista personal como «su» plan, y meterle uno de empleo la
	// dejaría pidiendo los saldos de un plan que no es suyo.
	if (target === ViewType.INDIVIDUAL) onSelectPersonalPlan?.(plan.id);
	onOpenPlan?.(plan.id);
	setViewType(target);
	navigateToDefaultTab(target);
};
